<template>
  <ModalButton :href="subscriptionPage" text="Get credits" />
</template>

<script>
import ModalButton from 'components/Buttons/ModalButton.vue'
export default {
  components: { ModalButton },
  data: () => ({
    subscriptionPage: process.env.WEBSITE_URL + 'subscription/?type=user#plan-wrapper'
  })
}
</script>
